import { useState } from "react";
import { twclsx } from "../../utils/cssUtil";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";

export function CollapseText({
  summary,
  details,
}: {
  summary: string;
  details: string;
}) {
  const { t } = useTranslation();
  const [collapsed, setCollapse] = useState(true);
  return (
    <>
      <div
        className={twclsx(
          "collapse bg-base-200/50 rounded-md p-3 m-2 w-auto",
          !collapsed && "collapse-open",
        )}
      >
        <div
          className={twclsx(collapsed && "line-clamp-6")}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(summary) }}
        ></div>
        <div
          className={twclsx(
            "collapse-content p-0",
            !collapsed && "py-5",
            "whitespace-pre-line",
          )}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(details) }}
        ></div>
        <div
          className={"cursor-pointer text-sm flex justify-center text-gray-500"}
          onClick={() => {
            setCollapse(!collapsed);
          }}
        >
          {collapsed ? (
            <>
              {t("userdetail_btn_fold")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                className="size-4 my-auto"
              >
                <path
                  fillRule="evenodd"
                  d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                  clipRule="evenodd"
                />
              </svg>
            </>
          ) : (
            <>
              {t("userdetail_btn_unfold")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                className="size-4 my-auto"
              >
                <path
                  fillRule="evenodd"
                  d="M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z"
                  clipRule="evenodd"
                />
              </svg>
            </>
          )}
        </div>
      </div>
    </>
  );
}
